<script>
    import Card from "../Components/bootstrap/Card.svelte";
    import Carousel from "../Components/Carousel.svelte";
    import title from '../constantes'
</script>

<div class="card-group group w-75 h-75 mx-auto">

    {#if !window.location.href.includes("/contactenos")}
        <Carousel />
    {/if}

    {#if window.location.href.includes("/contactenos")}
    <div class="row w-100">
        <div class="col-12 col-lg-8">
            <iframe height="450px" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d990.2421438803754!2d-70.704389595852!3d-33.40331354042882!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662c6a5817b1f07%3A0xa5a014879da7ab7e!2sDoctora%20Liliana%20Mart%C3%ADnez!5e0!3m2!1ses!2sco!4v1678876341425!5m2!1ses!2sco" title="Ubicación {title}" style="border:0; width:100%;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
        <div class="col-12 col-lg-4 p-4">
            <address><strong>Teléfono:</strong> <br>+56 9 9744 4028</address>
            <address><strong>Dirección:</strong> <br>José Manuel Balmaceda N°4149 Renca Oficina 2F – Santiago</address>
        </div>
    </div>
    {/if}


    {#if !window.location.href.includes("/contactenos")}
        <div class="col-12 col-md-6 col-lg-3">
            <Card cardTitle="Odontología" 
            cardText="Mantenemos el Cuidado y Tratamiento Especial de las encías de nuestros pacientes,reiterando en cada visita la enseñanza de Técnicas Correctas de Higiene Dental."
            imageURL="./images/cards/Odontología.jpg"
            />
        </div>
        <div class="col-12 col-md-6 col-lg-3">
            <Card cardTitle="Odontopediatría" 
            cardText="Nos preocupamos de establecer una relación de empatía con nuestros pacientes niños,a quienes atendemos con especial cuidado"
            imageURL="./images/cards/Odontopediatría.jpg"
            />
        </div>
        <div class="col-12 col-md-6 col-lg-3">
            <Card cardTitle="Estética Dental" 
            cardText="Siendo conscientes de la importancia que tiene para nuestros pacientes lucir una bella sonrisa, realizamos Blanqueamientos Dentales, cambiando su look, mediante el Diseño de Sonrisas."
            imageURL="./images/cards/Estética Dental.jpg"
            />
        </div>
        <div class="col-12 col-md-6 col-lg-3">
            <Card cardTitle="Ortodoncia" 
            cardText="¿Desea mejorar la posición y estética de sus dientes?"
            imageURL="./images/cards/Ortodoncia.jpg"
            />
        </div>
    {/if}

    
</div>